import { CSSProperties } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { Text } from '@shared/components/Text';
import { DateField } from '@shared/data/entity/fields/DateField';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: DateField;
  style: StyleProp<ViewStyle>;
  textStyle?: CSSProperties;
}

export function DateCollectionViewField({ field, style, textStyle }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer style={style}>
      <Text size="body1" style={textStyle} numberOfLines={1}>
        {field.formattedDate}
      </Text>
    </CardCollectionViewFieldContainer>
  );
}
